import { isEmpty } from 'underscore';
import {
  DATA_SOURCE_KEY_MAPPING,
  validateEmailAddress,
  validatePhone,
  isValidUrl,
} from '@bingads-webui-campaign-react/smart-component-util';

import { getActionButtonProps } from './get-action-button-props';
import { DATA_SOURCE_NAME, SmartActionButtonTypes } from './smart-action-types';

// TODO: Refactor the validation rule(Nickyang)
export function smartActionButtonValidator({ siteConfig, componentId, i18n }) {
  const {
    actionType,
    dataSourceName,
    dataSourceValue,
    linkText,
    linkUrl,
    isTextEditable,
    isLinkEditable,
    componentConfig,
  } = getActionButtonProps(siteConfig, componentId);
  let useDataSource = !isEmpty(dataSourceName);

  // TODO: Refactor this place. Validation according to each actionType
  if (actionType === SmartActionButtonTypes.BookAppointment.name) {
    useDataSource = componentConfig[DATA_SOURCE_NAME] === dataSourceName;
  }

  if (isLinkEditable && !isValidUrl(linkUrl)) {
    return {
      isValid: false,
      errors: !i18n ? null : [i18n.getString(_TL_('Invalid URL'))],
    };
  }

  let isValid = true;

  if (useDataSource) {
    if (dataSourceName === DATA_SOURCE_KEY_MAPPING.PhoneNumber &&
      !validatePhone(dataSourceValue)) {
      return {
        isValid: false,
        errors: !i18n ? null : [i18n.getString(_TL_('Invalid phone number'))],
      };
    } else if (dataSourceName === DATA_SOURCE_KEY_MAPPING.Emails &&
      !validateEmailAddress(dataSourceValue)) {
      return {
        isValid: false,
        errors: !i18n ? null : [i18n.getString(_TL_('Invalid email address'))],
      };
    } else if (isEmpty(dataSourceValue)) {
      isValid = false;
    }
  }

  if (isTextEditable && isEmpty(linkText)) {
    isValid = false;
  }

  return {
    isValid,
    errors: isValid || !i18n ? null : [i18n.getString(_TL_('Required field is empty'))],
  };
}
